<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-balance-scale mr-2" />Grosir / Eceran
            </h5>
            <hr />
            <b-row class="mb-3">
                <!-- <b-col md="6">
                    <div class="small text-muted">
                        Perubahan terakhir pada {{ $helper.parseDate(mode == 1 ? hpLastUpdated.at : nonHpLastUpdated.at) }}, {{ $helper.parseHourMinute(mode == 1 ? hpLastUpdated.at : nonHpLastUpdated.at) }}<br />
                        oleh {{ mode == 1 ? hpLastUpdated.by : nonHpLastUpdated.by }}
                    </div>
                </b-col> -->
                <b-col md="12" class="text-right">
                    <b-button variant="dark" @click="addRow(-1)">
                        <i
                            :disabled="isSubmitting || isBusy"
                            class="fa fa-plus mr-2"
                        ></i>
                        Tambah Baris Paling Atas
                    </b-button>
                </b-col>
            </b-row>
            <b-table
                responsive
                bordered
                no-local-sorting
                :fields="fields"
                :items="items"
                @sort-changed="onSortChanged"
            >
                <template v-slot:cell(from)="row">
                    <b-input-group prepend="Rp.">
                        <b-form-input
                            v-model="row.item.from"
                            class="text-right"
                            @keypress="onInputKeyPress"
                            @input="sanitize(row.item, 'from')"
                        ></b-form-input>
                    </b-input-group>
                </template>
                <template v-slot:cell(to)="row">
                    <b-input-group prepend="Rp.">
                        <b-form-input
                            v-model="row.item.to"
                            class="text-right"
                            @keypress="onInputKeyPress"
                            @input="sanitize(row.item, 'to')"
                        ></b-form-input>
                    </b-input-group>
                </template>
                <template v-slot:cell(increase)="row">
                    <b-input-group prepend="Rp.">
                        <b-form-input
                            v-model="row.item.increase"
                            class="text-right"
                            @keypress="onInputKeyPress"
                            @input="sanitize(row.item, 'increase')"
                        ></b-form-input>
                    </b-input-group>
                </template>
                <template v-slot:cell(action)="row">
                    <div style="width: 80px; margin-top: 2px">
                        <b-button
                            size="sm"
                            variant="primary"
                            :disabled="isSubmitting || isBusy"
                            class="mr-2"
                            v-b-tooltip.hover
                            title="Tambah"
                            @click="addRow(row.index)"
                        >
                            <i class="fa fa-plus"></i>
                        </b-button>
                        <b-button
                            size="sm"
                            variant="danger"
                            :disabled="isSubmitting || isBusy"
                            v-b-tooltip.hover
                            title="Hapus"
                            @click="deleteRow(row.index)"
                        >
                            <i class="fa fa-times"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
            <div class="text-right mt-3">
                <b-button variant="success" @click="confirmSave">
                    Simpan Perubahan
                </b-button>
            </div>
        </b-card>
        <b-modal
            id="m-confirm"
            title="Simpan Perubahan"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            Simpan rumus penambahan harga barang untuk pembelian eceran?
            <!-- <div class="small text-muted">Harga 'sampai' terakhir akan otomatis diubah menjadi 99 miliar ketika disimpan.</div> -->
            <div class="text-right mt-4">
                <b-button
                    variant="primary"
                    @click="execSave"
                    :disabled="isSubmitting"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            isFetching: false,

            fields: [
                { key: "from", label: "Harga Grosir Dari", sortable: true },
                { key: "to", label: "Harga Grosir Sampai", sortable: true },
                {
                    key: "increase",
                    label: "Tambahan Harga Eceran",
                    sortable: true,
                },
                { key: "action", label: "Aksi", sortable: false },
            ],

            inputs: ["from", "to", "increase"],

            items: [],

            // sortBy: null,
            // sortDesc: false
        };
    },

    methods: {
        onInputKeyPress(event) {
            const charCode =
                typeof event.which === "number" ? event.which : event.keyCode;

            if (
                charCode !== 44 &&
                charCode !== 46 &&
                (charCode < 48 || charCode > 57)
            ) {
                event.preventDefault();
            }
        },
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        getItems() {
            this.isBusy = true;
            let param = "";

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            this.$axios
                .get("/admin/getRetailPricing" + param)
                .then((res) => {
                    // let data = res.data.data
                    this.items = res.data.data;
                    this.sanitizeAll();
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        confirmSave() {
            if (this.items.length > 0 && this.items[0].from != "0") {
                return this.$helper.toastError(
                    this,
                    "Baris pertama harus dimulai dengan dari Rp 0!"
                );
            }

            for (var i = 0; i < this.items.length; i++) {
                for (var j = 0; j < this.inputs.length; j++) {
                    if (this.items[i][this.inputs[j]] == "") {
                        return this.$helper.toastError(
                            this,
                            "Terdapat kotak yang kosong, mohon cek kembali!"
                        );
                    }
                }
            }

            this.$bvModal.show("m-confirm");
        },

        execSave() {
            let entries = [];
            if (this.items.length > 0) {
                this.items.forEach((it) => {
                    entries.push({
                        from: this.$helper.toNumber(it.from),
                        to: this.$helper.toNumber(it.to),
                        increase: this.$helper.toNumber(it.increase),
                    });
                });
            } else {
                entries = this.items;
            }

            let payload = {
                pricingList: entries,
            };

            this.isSubmitting = true;

            this.$axios
                .post("/admin/updateRetailPricing", payload)
                .then((res) => {
                    let data = res.data.data;

                    this.getItems();

                    this.$bvModal.hide("m-confirm");
                    this.$helper.toastSuccess(
                        this,
                        "Rumus umum untuk berhasil disimpan!"
                    );
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        addRow(index) {
            this.items.splice(index + 1, 0, { from: "", to: "", increase: "" });
        },

        deleteRow(index) {
            this.items.splice(index, 1);
        },

        sanitize(item, varName) {
            let cleaned = String(item[varName]).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            item[varName] = res;
        },

        sanitizeAll() {
            this.items.forEach((it) => {
                this.inputs.forEach((v) => this.sanitize(it, v));
            });
        },
    },

    created() {
        this.init();
    },
};
</script>
